(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["components"] = factory();
	else
		root["components"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 82);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(14);

var componentPropTypes = exports.componentPropTypes = {
  htmlFor: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.any.isRequired
};

var InlineLabel = function InlineLabel(props) {
  return _react2.default.createElement(
    'label',
    _extends({ className: 'inline-label__tag', htmlFor: props.htmlFor }, props),
    props.children
  );
};

InlineLabel.propTypes = componentPropTypes;

exports.default = InlineLabel;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentPropTypes = exports.oneOfProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(16);

var oneOfProps = exports.oneOfProps = {
  options: _propTypes2.default.object
};

var componentPropTypes = exports.componentPropTypes = {
  id: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.arrayOf(oneOfProps.options).isRequired,
  className: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

var Select = function Select(props) {
  return _react2.default.createElement(
    'select',
    _extends({}, (0, _omit2.default)(['options'])(props), {
      name: props.name || props.id,
      value: props.value }),
    props.options.map(function (key) {
      return _react2.default.createElement(
        'option',
        { value: key.value, disabled: key.disabled, key: (props.name || props.id) + '-' + key.value },
        key.label
      );
    })
  );
};

Select.propTypes = componentPropTypes;

exports.default = Select;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(18);

var componentPropTypes = exports.componentPropTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  required: _propTypes2.default.bool,
  touched: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

var TextArea = function TextArea(props) {
  return _react2.default.createElement('textarea', _extends({}, (0, _omit2.default)(['touched', 'error'])(props), {
    className: (0, _classnames2.default)(props.className, {
      'textarea--alert': props.touched && props.error
    }),
    name: props.id,
    value: props.value
  }));
};

TextArea.propTypes = componentPropTypes;

exports.default = TextArea;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.componentPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(20);

var componentPropTypes = exports.componentPropTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  required: _propTypes2.default.bool,
  touched: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};

var defaultProps = exports.defaultProps = {
  type: 'text'
};

var TextField = function TextField(props) {
  return _react2.default.createElement('input', _extends({}, (0, _omit2.default)(['error', 'touched'])(props), {
    className: (0, _classnames2.default)(props.className, {
      'input--alert': props.touched && props.error
    }),
    name: props.name || props.id,
    value: props.value
  }));
};

TextField.propTypes = componentPropTypes;
TextField.defaultProps = defaultProps;
exports.default = TextField;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/fp/omit");

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(83);


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentPropTypes = exports.oneOfProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _InlineLabel = __webpack_require__(84);

var _InlineLabel2 = _interopRequireDefault(_InlineLabel);

var _TextField = __webpack_require__(85);

var _TextField2 = _interopRequireDefault(_TextField);

var _TextArea = __webpack_require__(86);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _Select = __webpack_require__(87);

var _Select2 = _interopRequireDefault(_Select);

var _omit = __webpack_require__(3);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(88);

var oneOfProps = exports.oneOfProps = {
  fieldType: ['input', 'textarea', 'select', 'text', 'email', 'number', 'password']
};

var componentPropTypes = exports.componentPropTypes = {
  id: _propTypes2.default.string.isRequired,
  fieldType: _propTypes2.default.oneOf(oneOfProps.fieldType).isRequired,
  label: _propTypes2.default.any.isRequired,
  value: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  className: _propTypes2.default.string
};

var getContents = function getContents(props) {
  switch (props.fieldType) {
    case 'input':
      return _react2.default.createElement(_TextField2.default, (0, _omit2.default)(['fieldType'])(props));
    case 'text':
    case 'email':
    case 'number':
    case 'password':
      return _react2.default.createElement(_TextField2.default, _extends({}, (0, _omit2.default)(['fieldType'])(props), { type: props.fieldType }));
    case 'textarea':
      return _react2.default.createElement(_TextArea2.default, (0, _omit2.default)(['fieldType'])(props));
    case 'select':
      return _react2.default.createElement(_Select2.default, (0, _omit2.default)(['fieldType'])(props));
    default:
      console.warn('InlineFormField Warning: The type: ' + props.fieldType + ' doesn\'t exist. Returning nothing');
      return;
  }
};

var InlineFormField = function InlineFormField(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('inline-label', props.className) },
    _react2.default.createElement(
      _InlineLabel2.default,
      { htmlFor: props.id },
      props.label
    ),
    getContents(props)
  );
};

InlineFormField.propTypes = componentPropTypes;

exports.default = InlineFormField;

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineLabel = __webpack_require__(13);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = __webpack_require__(19);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextArea = __webpack_require__(17);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextArea).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(15);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Select).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/wonderbly-components/lib/InlineFormField.js
// module id = 171
// module chunks = 0